// generated using https://yoksel.github.io/url-encoder/

export const defaultAssetInlineEncoded = `data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3Csvg width='40' height='41' viewBox='0 0 40 41' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='20' cy='20.5' r='20' fill='%23F4F4F4'/%3E%3C/svg%3E%0A`;
